<template>
  <div
    class="text-center empty-container"
    style=""
    :style="{ width: '100%', height: height + 'px' }"
  >
    <v-icon :size="iconSize" class="mb-4" color="grey lighten-2">
      {{ icon }}
    </v-icon>
    <div
      class="font-weight-light"
      color="grey"
      style="color:#bbbbbb;"
      :style="{ fontSize: messageSize + 'px !important' }"
    >
      {{ message }}
    </div>
    <div class="mt-2">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "EmptyListPlaceholder",
  props: {
    iconSize: {
      type: Number,
      default: 70
    },
    height: {
      type: Number,
      default: 100
    },
    icon: {
      type: String,
      default: () => "mdi-alert-circle-outline"
    },
    message: {
      type: String,
      default: () => "No informations found for this list"
    },
    messageSize: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped>
.empty-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
